import { useEffect, type ReactNode } from 'react';
import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

type PublicCatalogModalProps = {
  onClose: () => void;
  children: ReactNode;
  labelledBy?: string;
  /** Replaces the default wide, scrollable card. */
  cardClassName?: string;
  showClose?: boolean;
};

const PublicCatalogModal = ({
  onClose,
  children,
  labelledBy,
  cardClassName = 'max-w-lg max-h-[90dvh] overflow-y-auto',
  showClose = true,
}: PublicCatalogModalProps) => {
  const { t } = useTranslation();

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  return (
    <div
      className="fixed inset-0 z-[120] flex items-center justify-center bg-black/60 p-3 sm:p-6"
      onClick={onClose}
      role="presentation"
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby={labelledBy}
        className={`relative w-full rounded-2xl bg-card shadow-2xl ${cardClassName}`}
        onClick={(event) => event.stopPropagation()}
      >
        {showClose && (
          <button
            type="button"
            onClick={onClose}
            aria-label={t('marketplace.catalogues.lookbook.close')!}
            className="absolute right-3 top-3 z-10 inline-flex h-8 w-8 items-center justify-center rounded-full bg-black/10 text-foreground transition hover:bg-black/20 dark:bg-white/10 dark:hover:bg-white/20"
          >
            <X className="h-4 w-4" />
          </button>
        )}
        {children}
      </div>
    </div>
  );
};

export default PublicCatalogModal;
